import React from 'react'
import { observer } from 'mobx-react-lite'
import clsx from 'clsx'

import { makeStyles } from '@material-ui/core/styles'
import { Box, FormControl, FormHelperText, Grid, InputLabel, Typography } from '@material-ui/core'

import { MyServerTable } from './MyServerTable'
import { BootstrapInput } from './BootstrapInput'
import { OzonProductsArchivedFilter } from './OzonProductsArchivedFilter'
import { OzonTableHasMsProductFilter } from './OzonTableHasMsProductFilter'
import { ExportFileKind, ExportToExcelButton } from './ExportToExcelButton'

import { OzonProductsTableData } from '../store/productStore'

import { TableColumn } from '../types/tableTypes'
import { OzonProductColumnId } from '../types/ozonColumns'
import { OzonProductModel } from '../server/mpsklad_core/Models/OzonProductModel'

import { useApi } from '../hooks/storeHook'

export type OzonProductsTableProps = {
  products: OzonProductsTableData

  columns: Array<TableColumn<OzonProductColumnId, OzonProductModel>>

  accountId?: number
  accountName?: string
}

export const OzonProductsTable =
  observer(
    ({products, columns, accountId, accountName}: OzonProductsTableProps) => {
      const classes = useStyles()
      const api = useApi()

      return (
        <Grid item lg={12} xl={12}>
          <Box className={clsx(classes.container, 'default-border')}>
            <Box paddingTop={1} marginY={2} marginLeft={2} display="flex" alignItems="center">
              <Typography className={classes.label}>
                Товары
              </Typography>

              {
                accountId !== undefined &&
                <Box marginLeft={2}>
                  <ExportToExcelButton
                    fileKind={ExportFileKind.Products}
                    columns={columns}
                    accountName={accountName}
                    makeExportRequest={columnIds => api.product.exportOzonToExcel({
                      ...products.getExportOptions(),
                      accountId,
                      columnIds
                    })}
                  />
                </Box>
              }

              <Box marginLeft={25}>
                <Box>
                  <FormControl fullWidth>
                    <InputLabel shrink htmlFor="search-ozon">
                      Поиск
                    </InputLabel>
                    <BootstrapInput
                      id="search-ozon"
                      placeholder="Поиск"
                      onChange={e => products.setGlobalFilter(e.target.value)}
                      inputProps={{'aria-label': 'Поиск'}}
                      fullWidth
                    />

                    <FormHelperText>Id / Артикул / Наименование / Штрихкод</FormHelperText>
                  </FormControl>
                </Box>
              </Box>

              <Box marginLeft={5}>
                <OzonTableHasMsProductFilter products={products}/>
              </Box>

              <Box marginLeft={5}>
                <OzonProductsArchivedFilter products={products}/>
              </Box>
            </Box>

            <MyServerTable
              tableProps={{size: 'small'}}
              table={products}
              columns={columns}
              labelNoRows="Товаров нет"
              labelNotFound="Товары не найдены"
              labelRowsPerPage="Товаров на странице:"
            />
          </Box>
        </Grid>
      )
    })

const useStyles = makeStyles(() => ({
  container: {
    minWidth: 'calc(100vw - 410px)',
    borderRadius: 12,
    padding: 30,
    marginTop: 10
  },
  label: {
    fontSize: 14,
    padding: 10
  },
  input: {
    fontSize: 12,
    height: 40
  }
}))